import Store from 'store/store';

const fire = (action, cat, label) => {
	if (!window.firePowsterCustomEvent) return;
	window.firePowsterCustomEvent(action, cat, label);
};

Store.on('TRACK_POWER_RANDOMISER_CLICK', () => {
	fire('power-button-click', 'name', '-');
});